import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChargingStation: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="charging-station, electric-current, power, e-charge"><path d="M13.25 14.75V3.75H3.75V14.75M13.25 14.75V20.25H3.75V14.75M13.25 14.75H3.75" stroke="currentColor" strokeWidth="1.5"/><path d="M3.75 20.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.75 10.75V16.25H20.25V7.25L17.25 4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.21429 6.28577L6 10.2143H7.78571V12.7143L11 8.78577H9.21429V6.28577Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChargingStation;
